/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-mixins */
import { action } from '@ember/object';
import Controller from '@ember/controller';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';

export default class IndexController extends Controller.extend(EditPostMixin) {
  queryParams = ['offset'];
  offset = 0;
  PostTypes = PostTypes;

  @action
  refresh() {
    this.model.posts.update();
  }

  @action
  nextPage() {
    this.incrementProperty('offset', 20);
  }

  @action
  prevPage() {
    this.decrementProperty('offset', 20);
  }
}
